import DisplaySticky from "./DisplaySticky";

function DisplayStickyFooter() {
	return <DisplaySticky position="bottom" />;
}

export default DisplayStickyFooter;
